<template>
  <div>
    <collapse :active-index="0">
      <collapse-item>
        <template slot="title">
          <div class="row">
            <div class="col d-flex align-items-center">
              <h3 class="mb-0">Pedidos Asociados</h3>
              <router-link
                v-if="$can('associate_order', 'projections') && canAssociateOrder"
                :to="{ name: 'ProjectionAssociateOrders' }"
                class="btn base-button btn-primary btn-sm mx-2"
                >Asociar Pedido
              </router-link>
            </div>

            <div class="col text-right pr-5"></div>
          </div>
        </template>
        <ul class="list-group list-group-flush list my--3">
          <li v-for="order in orders" :key="order.id" class="list-group-item px-0">
            <div>
              <h3>
                <router-link v-if="$can('show', 'orders')" :to="{ name: 'OrderShow', params: { id: order.id } }">
                  Pedido {{ order.code }}
                </router-link>
                <template v-else> Pedido {{ order.code }} </template>
                <badge v-if="order.deletedAt" type="danger" class="m-1">Eliminado</badge>
                <small v-if="order.deletedAt" class="text-break"
                  >por {{ order.updatedBy.name }} el {{ order.deletedAt | date }}</small
                >
                <badge v-else :type="getColor(order)" class="m-1">{{ order.state.label }}</badge>
              </h3>
            </div>
            <br />
            <div class="row">
              <div class="col-sm-6 col-xs-12">
                <div>
                  <label class="control-label font-weight-bold mr-2">FECHA FACTURACIÓN: </label>
                  <span>{{ order.billingDate | date('DD/MM/YYYY') }}</span>
                </div>
                <div>
                  <label class="control-label font-weight-bold mr-2">FECHA PRIMER PAGO: </label>
                  <span>{{ order.firstPaymentDate | date('DD/MM/YYYY') }}</span>
                </div>
                <div>
                  <label class="control-label font-weight-bold mr-2">CANTIDAD DE PAGOS: </label>
                  <span>{{ order.payments }}</span>
                </div>
              </div>
              <div class="col-sm-5 offset-sm-1 col-xs-12">
                <div>
                  <label class="control-label font-weight-bold mr-2">FECHA COTIZACIÓN DOLAR: </label>
                  <span>{{ order.dollarQuoteDate | date('DD/MM/YYYY') }}</span>
                </div>
                <div>
                  <label class="control-label font-weight-bold mr-2">COTIZACIÓN DOLAR: </label>
                  <span>{{ +order.dollarQuote | toCurrencyARS }}</span>
                </div>
                <div v-if="itemsLoaded(order)">
                  <label class="control-label font-weight-bold mr-2">TOTAL EN DÓLARES: </label>
                  <span>{{ total(order) | toCurrencyUSD }}</span>
                </div>
                <div v-if="itemsLoaded(order)">
                  <label class="control-label font-weight-bold mr-2">TOTAL EN PESOS: </label>
                  <span>{{ totalInArs(order) | toCurrencyARS }}</span>
                </div>
              </div>

              <div v-if="order.comment" class="col-sm-12 col-xs-12">
                <div>
                  <label class="control-label font-weight-bold mr-2">OBSERVACIONES: </label>
                  <span>{{ order.comment }}</span>
                </div>
              </div>

              <div v-if="order.statusChangeComment" class="col-sm-12 col-xs-12">
                <div class="mt-2">
                  <label class="control-label font-weight-bold mr-2">OBSERVACIONES SOBRE ESTADO DE PEDIDO: </label>
                  <span>{{ order.statusChangeComment }}</span>
                </div>
              </div>
            </div>
          </li>
          <li v-if="orders.length === 0" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="mb-0">Esta Proyección no tiene Órdenes asociadas.</h4>
              </div>
            </div>
          </li>
        </ul>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import OrdersService from '@/services/resources/orders.service';
import OrderStatesMixin from '@/mixins/orderStatesMixin';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'OrdersList',
  components: {
    Collapse,
    CollapseItem,
  },

  mixins: [OrderStatesMixin],
  props: {
    projectionId: null,
    isProjectionConfirmed: {
      type: Boolean,
      required: true,
    },

    canAssociateOrder: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      orders: [],
      IVA: 0,
    };
  },

  created() {
    this.fetchTableData();
    this.IVA = process.env.VUE_APP_IVA;
  },

  methods: {
    fetchTableData() {
      const params = {
        include: ['producer.distributor.seller', 'campaign', 'user', 'state', 'items.article'],
        'filter[projection]': this.projectionId,
        'filter[withTrahed]': true,
      };
      this.$services
        .resource('orders')
        .get(params)
        .then((res) => {
          return res.data.data;
        })
        .then((data) => this.afterFetchData(data.orders));
    },

    afterFetchData(orders) {
      if (orders.length > 0) {
        this.orders = orders;
        if (!this.isProjectionConfirmed) {
          this.orderAssignmentPermission();
        }
      }
    },

    orderAssignmentPermission() {
      if (this.ordersValidation()) {
        this.$emit('freezeOrders');
      }
    },

    ordersValidation() {
      for (let index = 0; index < this.orders.length; index++) {
        if (
          this.isOpen(this.orders[index]) ||
          this.isPending(this.orders[index]) ||
          this.isAccepted(this.orders[index])
        ) {
          if (!this.isDeleted(this.orders[index])) {
            return true;
          }
        }
      }
    },

    isOpen(order) {
      return order.state.name == OrdersService._STATE_OPEN;
    },

    isPending(order) {
      return order.state.name == OrdersService._STATE_PENDING;
    },

    isAccepted(order) {
      return order.state.name == OrdersService._STATE_ACCEPTED;
    },

    isDeleted(order) {
      return order.deletedAt;
    },

    subtotal(order) {
      return order.items.reduce((acc, i) => (acc += i.quantity * i.price), 0);
    },

    total(order) {
      return +(this.subtotal(order) * (1 + this.IVA / 100));
    },

    totalInArs(order) {
      return +(this.total(order) * order.dollarQuote);
    },

    itemsLoaded(order) {
      return order.items.length > 0 ? true : false;
    },
  },
};
</script>
